module.exports = __webpack_public_path__ + "static/img/noDate.a1f98b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/noDate.png
// module id = vkOU
// module chunks = 2